// Generated from src/img/svg/s.svg

export const S = (props) => {
  return (
    <svg height="25" viewBox="0 0 23.925 23.925" width="25" {...props}>
      <path
        d="M23.925 11.962a11.962 11.962 0 1 0-11.963 11.963 11.973 11.973 0 0 0 11.963-11.963"
        style={{ fill: "#4d9046", fillRule: "evenodd" }}
      />
      <path
        d="M19.815 15.144c0 2.9-2.814 6.274-7.551 6.274a12.07 12.07 0 0 1-7.355-2.68v-3.766a9.4 9.4 0 0 0 7.355 4.024c1.775 0 3.201-1.014 3.201-2.1 0-4.087-10.709-1.56-10.709-8.608 0-3.7 3.613-5.69 6.857-5.69a11.4 11.4 0 0 1 7.053 2.378v3.14a9.91 9.91 0 0 0-7.115-3.379c-1.665 0-2.617.885-2.617 1.924 0 4.373 10.88 1.301 10.88 8.484"
        style={{ fill: "#fff", fillRule: "evenodd" }}
      />
      <path d="M0 0h23.925v23.925H0z" style={{ fill: "none" }} />
    </svg>
  );
};
